import { fb, validators } from '../../../../lib/form';

export function getProposalFormModel(data) {
    
    const interestedList = [
        { name: 'Custom software for my business', value: 'Custom software for my business' },
        { name: 'IT Support', value: 'IT Support' },
        { name: 'Microsoft Exchange', value: 'Microsoft Exchange' },
        { name: 'TrendMicro', value: 'TrendMicro' },
        { name: 'Desktop', value: 'Desktop' },
        { name: 'Laptop', value: 'Laptop' },
        { name: 'Windows Server', value: 'Windows Server' },
        { name: 'Networking', value: 'Networking' },
        { name: 'Legacy Software Support', value: 'Legacy Software Support(VBA, VB6)' },
        { name: 'Application Modernisation', value: 'Application Modernisation'},
        { name: 'MYOB Apps', value: 'MYOB Apps'},
        { name: 'Other', value: 'Other' }
    ];

    const budgetList = [
        { name: 'Less than $1k', value: 'Less than $1k' },
        { name: '$1k - $5k', value: '$1k - $5k' },
        { name: '$5k - $10k', value: '$5k - $10k' },
        { name: '$10k - 20k', value: '$10k - 20k' },
        { name: '$20k - 50k', value: '$20k - 50k' },
        { name: '$50k +', value: '$50k +' },
        { name: 'Not sure', value: 'Not sure' },
    ];
    
    const model = fb.group({
      name: [data.name || '', [validators.Required()], { label: 'Name', type: 'text' }],
      email: [data.email || '', [validators.Required(), validators.Email()], { label: 'Email', type: 'email' }],
      phone: [data.phone || '', [validators.Required()], { label: 'Phone', type: 'text' }],
      details: [data.details || '', [validators.Required()], { label: 'Project Details', type: 'textarea' }],
      interested: [data.interested || [], [], { label : 'I am interested in ...', type: 'checkboxList', options: interestedList, style: { inline: false } }],
      budget: [data.budget || '', [validators.Required('Please select your choice.')], { label : 'Available Budget ...', type: 'radioList', options: budgetList, style: { inline: false } }],
      attachments: [data.attachments || '', [], { label: 'Attachments', type: 'file' }]
    }); 
    return model;
  }